import React, { useEffect, useState } from 'react';
import classes from "./CategoryVideoPlay.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import VideoPlayer from '../components/Player/VideoPlayer';

const CategoryVideoPlay = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [video, setVideo] = useState(null);

    useEffect(() => {
        if (location?.state) {
            console.log(location?.state,'ls');
            setVideo(location?.state?.video);
        }
    }, [location]);

    return (
        <>
            {
                video?.video_src &&
                <VideoPlayer src={video?.video_src} autoPlay={false}
                    name={video?.name}
                />
            }
            {/* <main className={classes.main}>
             <header className={classes.header}>
                 <nav className={classes.nav}>
                     <div className={classes.logo_container}
                         onClick={() => {
                             navigate("/");
                         }}
                     >
                         <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                     </div>
                 </nav>
             </header>
             <section className={classes.section_landing_page}>
                 <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                 <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />
             </section>
         </main > */}
        </>

    )
}

export default CategoryVideoPlay